import { Container, ModalSheet } from '@boschebike/ebds-react';
import { FC } from 'react';
import { Button } from '../Button';
import { ModalAnnexProps } from '../types';

export const ModalAnnex: FC<ModalAnnexProps> = ({ content, actionLabelCancel, dispatchHide }) => (
  <ModalSheet.Content type="annex">
    <div id="tou-annex-modal">
      <Container>
        <div className="ebds-modal__content__body">
          <div
            className="ebds-modal__content__body__text"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />

          <div className="ebds-modal__content__body__actions">
            <Button
              mode="tertiary"
              icon={null}
              text={actionLabelCancel}
              onClick={dispatchHide}
            />
          </div>
        </div>
      </Container>
    </div>
  </ModalSheet.Content>
);
